import { IconButton, MenuItem, Stack, Typography } from '@mui/material';

import { ChevronDownIcon } from '../icons';
import { Menu } from '../menu';

import { SUPPORTED_COUNTRIES } from './config';
import { getFlagEmoji } from './lib';

type CountrySelectProps = {
  selectedIso2: string;
  onSelect: (iso2: string) => void;
  disabled?: boolean;
};

export const CountrySelect = (props: CountrySelectProps) => {
  const { selectedIso2, onSelect, disabled } = props;

  return (
    <Menu
      trigger={({ onClick }) => (
        <IconButton onClick={onClick} disabled={disabled} size="small" edge="start">
          <Typography component="span" fontSize={20} lineHeight={1}>
            {getFlagEmoji(selectedIso2)}
          </Typography>
          <ChevronDownIcon />
        </IconButton>
      )}
    >
      {({ close }) =>
        SUPPORTED_COUNTRIES.map((country) => (
          <MenuItem
            key={country.iso2}
            selected={country.iso2 === selectedIso2}
            onClick={() => {
              onSelect(country.iso2);
              close();
            }}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography component="span" fontSize={20} lineHeight={1}>
                {getFlagEmoji(country.iso2)}
              </Typography>
              <Typography>{country.name}</Typography>
              <Typography color="text.secondary">+{country.dialCode}</Typography>
            </Stack>
          </MenuItem>
        ))
      }
    </Menu>
  );
};
